import { v4 as uuidv4 } from 'uuid';

import { readCookie } from '@zapier/cookies';

import { EVENT_TYPE } from './constants';
import { emit } from './utils';

const TYPE = EVENT_TYPE.PARTNER_USER_INTERACTION;

type PartnerUserInteractionEvent = {
  absolute_url?: string;
  account_id: number;
  correlation_id: string;
  causation_id?: string;
  customuser_id?: number;
  event_action: 'click' | 'select' | 'in_view' | 'deselect';
  event_id?: string;
  identity_id?: string;
  integration_id: number;
  interaction_goal: string;
  interaction_name: string;
  referer?: string;
  release_id?: string;
  screen_size?: string;
  service_id?: number;
  timestamp_ms?: number;
  url_address?: string;
  user_agent?: string;
  visitor_id: string;
};

function emitPartnerUserInteractionEvent(eventProperties: {
  accountId: number;
  correlationId?: string;
  customuserId?: number;
  eventAction: 'click' | 'select' | 'in_view' | 'deselect';
  eventId?: string;
  integrationId?: number;
  interactionGoal: string;
  interactionName: string;
  serviceId?: number;
}) {
  const properties: PartnerUserInteractionEvent = {
    absolute_url: location.href,
    account_id: eventProperties.accountId,
    correlation_id: eventProperties.correlationId ?? uuidv4(),
    event_action: eventProperties.eventAction,
    event_id: eventProperties.eventId ?? uuidv4(),
    identity_id: readCookie('zapidentity'),
    integration_id: eventProperties.integrationId,
    interaction_goal: eventProperties.interactionGoal,
    interaction_name: eventProperties.interactionName,
    referer: document.referrer,
    release_id: process.env.COMMIT_HASH,
    screen_size: `${screen.width}x${screen.height}`,
    timestamp_ms: Date.now(),
    url_address: location.pathname,
    user_agent: navigator.userAgent,
    visitor_id: readCookie('visitor_id'),
  };
  if (eventProperties.customuserId) {
    properties.customuser_id = eventProperties.customuserId;
  }
  if (eventProperties.serviceId) {
    properties.service_id = eventProperties.serviceId;
  }

  emit(properties, TYPE);
}

export default emitPartnerUserInteractionEvent;
